export const environment = {
  production: true,
  keycloakBaseUrl: 'https://idm.jusbaires.gob.ar',
  apiBase: 'https://sij2.jusbaires.gob.ar/electoral-gateway',
  apiAdministracion: 'https://sij2.jusbaires.gob.ar/electoral-gateway/administracion-service/api/v1',
  apiSecciones: 'https://sij2.jusbaires.gob.ar/electoral-gateway/secciones-service/api/v1',
  apiUsuarios: 'https://sij2.jusbaires.gob.ar/electoral-gateway/usuarios-service/api/v1',
  apiBuscadorCircuitoService: 'https://sij2.jusbaires.gob.ar/electoral-gateway/buscador-circuito-service/api/v1',
  apiElecciones: 'https://sij2.jusbaires.gob.ar/electoral-gateway/administracion-service/api/v1',
  apiPadrones: 'https://sij2.jusbaires.gob.ar/electoral-gateway/padrones-service/api/v1',
  apiPadronesNativos: 'https://sij2.jusbaires.gob.ar/electoral-gateway/padrones-nativos-service/api/v1',
  apiAutoridadesMesas: 'https://sij2.jusbaires.gob.ar/electoral-gateway/autoridades-mesas-service/api/v1',
  logout: `https://idm.jusbaires.gob.ar/auth/realms/IOL-CABA/protocol/openid-connect/logout?redirect_uri=${document.location.protocol + '//' + document.location.hostname}`,
  apiAutoridadesMesa: 'https://sij2.jusbaires.gob.ar/electoral-gateway/autoridades-de-mesa-service/api/v1',
  apiCandidaturas: 'https://sij2.jusbaires.gob.ar/electoral-gateway/candidaturas-service/api/v1',

  apiEscrutinio: 'https://sij2.jusbaires.gob.ar/electoral-gateway/escrutinio-service/api/v1',
  urldondevoto: 'https://infractores.electoralcaba.gob.ar/#/gestion-reclamo-no-voto',

  apiKey: 'AIzaSyBhsKQQhToVeFK68Ps1G8pSx16nfxTJqzc',
  keycloakRealm: 'IOL-CABA',
  keycloakClientId: 'electoral-ui',
  reCaptchaKey: '6LcGqJ0qAAAAALeI9WhwkUKFo1WYFrM8zWuG3awH',
};

export const messages = {
  //errores status
  error_401: 'No autorizado',
  error_401_Desc: 'No tiene permisos para acceder a este recurso',
  error_403: 'Prohibido',
  error_403_Desc: 'No tiene permisos para acceder a este recurso',
  error_404: 'No encontrado',
  error_404_Desc: 'El recurso solicitado no se encontró',
  error_500: 'Error interno del servidor',
  error_500_Desc: 'Se produjo un error inesperado en el servidor',
  error_502: 'Error de puerta de enlace',
  error_502_Desc: 'Se produjo un error al intentar acceder al servidor',
  error_503: 'Servicio no disponible',
  error_503_Desc: 'El servidor no está disponible en este momento',

  //eliminar
  esta_seguro_eliminar: '¿Está seguro que desea eliminar este registro?',
  esta_seguro_desactivar: '¿Está seguro que desea desactivar este usuario?',
  no_elimino: 'No se pudo eliminar el registro',
  error_eliminar_registro: 'Error al eliminar el registro',
  // SUCCESS
  success_eliminar_registro: 'Se creó el registro correctamente',
  success_tomar_mesa: 'Se tomó la mesa correctamente',
  success_liberar_mesa: 'Se libero la mesa correctamente',

  //editar
  esta_seguro_editar: '¿Está seguro que desea editar este registro?',
  no_actualizacion: 'Se ha producido un error al actualizar el registro',
  error_actualizar_registro: 'No se pudo actualizar el registro',

  //crear
  esta_seguro_crear: '¿Está seguro que desea crear este registro?',
  esta_seguro_asignar: '¿Está seguro de que desea designar a la/s autoridad/es a la mesa y cargo originales del sorteo?',
  no_creacion: 'Se ha producido un error al crear registro',
  error_creacion_registro: 'No se pudo crear el registro',
  error_generacion_masiva: 'Error al ejecutar la generación masiva',
  success_proceso: 'Proceso ejecutado con éxito',
  error_proceso: 'Error al ejecutar el proceso',

  //validaciones
  campos_requeridos: 'Todos los campos son requeridos.',
  form_invalido: 'Formulario inválido.',
  fecha_pasada: 'La fecha no puede ser menor a la fecha actual',

  //informacion
  error_al_obtener_datos: 'Error al obtener datos',
  no_hay_datos: 'No hay registros que coincidan con esa búsqueda',
  no_info: 'No existe información para mostrar',
  actualizado_ok: 'Registro actualizado correctamente',
  no_hay_registros: 'No hay registros para mostrar',

  // title toastr
  title_success: 'Correcto',
  title_error: 'Error',
  title_warning: 'Advertencia',
  title_info: 'Información',

  //Descargar archivos
  esta_seguro_descargar: '¿Está seguro que desea descargar el archivo?',
  descarga_exitosa: 'El archivo se descargó correctamente',
  error_descarga_archivo: 'El archivo no se pudo descargar',
  archivo_descargado: 'El archivo se puede abrir en la carpeta de descargas.',
  archivo_vacio: 'El archivo está vacío y no contiene datos.',
  importacion_exitosa: 'La importación se realizó correctamente',
  archivo_vacio_aviso_importacion: 'No hay errores de importación registrados.',

  // Permisos
  sin_permisos_title: 'Sin permisos',
  sin_permisos: 'No tiene permisos para acceder a esta opción',
  error_permisos: 'Error al validar los permisos',

  // Errores Generales
  error_general: 'Se produjo un error inesperado en el sistema',

  // localStorage
  pagination: 'pagination',

  // ICONS
  iconos: 'Iconos',
  no_icons: 'No se encontraron iconos',

  // Images
  images: 'Imágenes',
  no_images: 'No se encontraron imágenes',
  err_images: 'Error al cargar las imágenes',
  err_convert_image: 'Error al convertir la imagen',

  // Menú
  error_menu: 'Error al cargar el menú',
  seleccione_menu_title: 'Seleccione un menú',
  seleccione_menu: 'Seleccione un menú para continuar',
  menu_seleccionado: 'Menú seleccionado correctamente',
  error_seleccion_menu: 'Error al seleccionar el menú',

  // Selección de opciones
  seleccione_opcion: 'Seleccione una opción',
  opcion_seleccionada: 'Opción seleccionada correctamente',
  error_seleccion_opcion: 'Error al seleccionar la opción',

  // Selección de usuario
  seleccione_usuario: 'Seleccione un usuario',
  usuario_seleccionado: 'Usuario seleccionado correctamente',
  error_seleccion_usuario: 'Error al seleccionar el usuario',

  // Keycloak
  error_keycloak: 'Error al obtener datos de Keycloak',

  // Barra lateral
  error_barra_lateral: 'Error al cargar la barra lateral',

  //importar
  esta_seguro_importar: '¿Está seguro que desea importar?',
  esta_seguro_importar_limpiar: '¿Está seguro que desea limpiar la lista y luego importar? No podrá recuperar los datos actuales.',
  error_importar: 'Se produjo un error al importar los archivos',
  success_importar: 'Se importaron los archivos correctamente',

  // Tareas
  tarea_correcta_title: 'Tarea realizada correctamente',
  tarea_correcta: 'La tarea ha sido realizada correctamente',

  //file name descargar padrones
  padron_caba: 'PADRON_CABA',

  //Guardar
  esta_seguro_guardar: '¿Desea guardar los cambios?',

  //Subsanar
  esta_seguro_subsanar: '¿Subsanar?',
  esta_seguro_eliminar_candidatos: '¿Está seguro que desea eliminar todos los candidatos?',

  //Candidato
  candidato_not_found: 'La persona no se encuentra en el padron',
};

export const actions = {
  edit: 'edit',
  create: 'create',
  delete: 'delete',
  save: 'save',
  designar: 'designar',
};
